// Dojo shop catalog (Phase 6). Two item classes, per the plan:
// cosmetics (pure material swaps on the avatar) and a hard cap of four
// gameplay modifiers so the balance stays sane. Prices are wallet coins.

export type ShopItemKind = 'gi' | 'headband' | 'modifier';

export interface ShopItem {
  id: string;
  kind: ShopItemKind;
  price: number;
  name: { en: string; de: string };
  description: { en: string; de: string };
  /** Cosmetic color (gi / headband) */
  color?: number;
}

export const SHOP_ITEMS: readonly ShopItem[] = [
  // --- Cosmetics: gi colors ---
  {
    id: 'gi-blue',
    kind: 'gi',
    price: 150,
    color: 0x2c5f8a,
    name: { en: 'Blue Gi', de: 'Blauer Gi' },
    description: { en: 'Classic competition blue.', de: 'Klassisches Wettkampf-Blau.' },
  },
  {
    id: 'gi-black',
    kind: 'gi',
    price: 300,
    color: 0x22222a,
    name: { en: 'Black Gi', de: 'Schwarzer Gi' },
    description: { en: 'For the serious budoka.', de: 'Für den ernsthaften Budoka.' },
  },
  {
    id: 'gi-red',
    kind: 'gi',
    price: 300,
    color: 0x9a2b2b,
    name: { en: 'Red Gi', de: 'Roter Gi' },
    description: { en: 'Impossible to miss.', de: 'Unübersehbar.' },
  },
  // --- Cosmetics: headbands ---
  {
    id: 'headband-gold',
    kind: 'headband',
    price: 200,
    color: 0xffd700,
    name: { en: 'Gold Headband', de: 'Goldenes Stirnband' },
    description: { en: 'Champion style.', de: 'Champion-Stil.' },
  },
  {
    id: 'headband-crimson',
    kind: 'headband',
    price: 120,
    color: 0xd93636,
    name: { en: 'Crimson Headband', de: 'Rotes Stirnband' },
    description: { en: 'Tied tight before every run.', de: 'Vor jedem Lauf fest gebunden.' },
  },
  // --- Gameplay modifiers (max 4 by design) ---
  {
    id: 'mod-double-shield',
    kind: 'modifier',
    price: 500,
    name: { en: 'Iron Spirit', de: 'Eiserner Geist' },
    description: {
      en: 'Second Wind absorbs two hits per run.',
      de: 'Second Wind fängt zwei Treffer pro Lauf ab.',
    },
  },
  {
    id: 'mod-magnet-plus',
    kind: 'modifier',
    price: 250,
    name: { en: 'Strong Magnet', de: 'Starker Magnet' },
    description: { en: 'Mega magnet lasts 2s longer.', de: 'Mega-Magnet hält 2s länger.' },
  },
  {
    id: 'mod-coin-value',
    kind: 'modifier',
    price: 350,
    name: { en: 'Lucky Coins', de: 'Glücksmünzen' },
    description: { en: 'Coins are worth 20% more.', de: 'Münzen sind 20% mehr wert.' },
  },
  {
    id: 'mod-combat-retry',
    kind: 'modifier',
    price: 400,
    name: { en: 'Second Chance', de: 'Zweite Chance' },
    description: {
      en: 'One combat mistake forgiven per fight.',
      de: 'Ein Fehler pro Kampf wird verziehen.',
    },
  },
];

export function shopItem(id: string): ShopItem | undefined {
  return SHOP_ITEMS.find((item) => item.id === id);
}
